<div class="m-t-16 enf-wrap">
  <button class="flex-initial" mat-button color="primary" navigateBack>
    <mat-icon class="materialSendIcon">arrow_back</mat-icon>
    <span class="customSendIconLeft"></span>
    <span [innerHtml]="'back' | translate | uppercase"></span>
  </button>

  <mtx-alert type="danger" [elevation]="2" [dismissible]="false" class="m-t-16">
    <h3 [innerHtml]="title | translate"></h3>
    <strong [innerHtml]="message | translate"></strong>
  </mtx-alert>
</div>
